import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";


import PodCasts from "./components/PodCasts";
import PodCast from "./components/PodCast";
import TranscriptPlayer from "./components/TranscriptPlayer";
function App() {
  return (
    <Router>
        <div className="w-full bg-linen font-poppins ">
          <Routes>
            <Route path="/" element={<TranscriptPlayer />} />
            <Route path="/podcasts" element={<PodCasts />} />
            <Route path="/podcasts/:podcastId" element={<PodCast />} />
            <Route path="/test-pod" 
              element={<Navigate to={"/?url=https://transcriptplayer.texelio.com/test-data/test_3.json"} 
              />} />
          </Routes>
        </div>
    </Router>
  );
}

export default App;
